import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// M2E.D: bundle fonts locally for offline kiosk reliability. The font
// family list must stay aligned with SUPPORTED_ACCENT_FONTS in
// apps/api/src/businesses/dto/businesses.dto.ts. Inter is the
// unconditional fallback (templates/shared/tokens.ts) and MUST be
// imported here so it's always available.
import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/playfair-display/400.css';
import '@fontsource/playfair-display/700.css';
import '@fontsource/lora/400.css';
import '@fontsource/lora/700.css';
import '@fontsource/bebas-neue/400.css';

import { App } from './App';

const root = document.getElementById('root');
if (!root) throw new Error('Root element missing');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
